export default __webpack_public_path__ + "static/media/path.f324e0da.svg";